import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaUniversity, FaUsers, FaGavel, FaRegBuilding } from 'react-icons/fa';

import PageHeader from '../../Components/PageHeader/PageHeader';
import CGoverment from '../../Components/CGoverment/CGoverment';
import CULB from '../../Components/CULB/CULB';
import CCorporate from '../../Components/CCorporate/CCorporate';

const Collaboration = () => {

    const pathname = window.location.pathname;
    let trimmedPathname = pathname;
    if (pathname.endsWith("/")) {
        trimmedPathname = pathname.slice(0, pathname.length - 1); // Remove trailing slash if present
    }
    const segments = trimmedPathname.split("/");
    const lastSegment = segments[segments.length - 1];

    const [activeId, setActiveId] = useState(lastSegment);

    const menuItems = [
        {
            id: 1,
            title: 'Goverment',
            path: 'govt',
            icon: <FaUniversity />,
            content: <CGoverment />
        },
        // {
        //     id: 2,
        //     title: 'Urban Local Bodies',
        //     path: 'ulb',
        //     icon: <FaUsers />,
        //     content: <CULB />
        // },
        // {
        //     id: 3,
        //     title: 'Corporate',
        //     path: 'corporate',
        //     icon: <FaGavel />,
        //     content: <CCorporate />
        // }
    ];

    return (
        <>
            <PageHeader
                title="Collaborations"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Collaboration' }
                ]}
            />

            <div className="container py-5">

                <div className='row'>
                    {/* Left Menu */}
                    <div className="col-md-3">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <div className="list-group">
                                <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                    Collaborations
                                </h5>
                                {menuItems.map((item) => (
                                    <button
                                        key={item.id}
                                        className={`list-group-item list-group-item-action d-flex mb-2 justify-content-start ${activeId === item.path ? 'active-menu' : ''}`}
                                        onClick={() => setActiveId(item.path)}
                                    >
                                        <span className="me-2 icon-text">{item.icon}</span> {item.title}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Content */}
                    <div className="col-md-9">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                {menuItems.find((item) => item.path === activeId)?.title}
                            </h5>
                            <div className="text-muted">
                                {menuItems.find((item) => item.path === activeId)?.content}
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </>
    );
};

export default Collaboration;